<template>
  <div class="Ben">
    <div class="banner-wrap">
      <div class="banner-text">
        <p>棒小呆 UI 设计</p>
        <p>笨笨学姐</p>
      </div>
      <img src="images/ben1.png" alt="">
    </div>
    <div class="service-wrap">
      <main-title title="业务介绍" color="#ec1e24"></main-title>
      <ul class="service-list">
        <li class="service-item" v-for="item in serviceList" :key="item.id">
          <div class="serv-show">
            <p class="serv-title">{{ item.servTitle }}</p>
          </div>
          <div class="serv-hover">
            <p class="serv-title">{{ item.servTitle }}</p>
            <p class="serv-text">{{ item.servText }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mainTitle from '@/components/title'
export default {
  name: 'ghidorah',
  components: {
    mainTitle
  },
  data() {
    return {
      bannerimg: './images/whxq/banner.jpg',
      serviceList: [
        {
          id: 1,
          servTitle: '官网设计',
          servText: '打造专业、易用的企业官网，强化品牌形象，提供清晰的信息架构和优质的用户体验'
        },
        {
          id: 2,
          servTitle: '电商设计',
          servText: '设计吸引人的在线商店，优化购物流程，提升转化率，创造无缝的购物体验'
        },
        {
          id: 3,
          servTitle: 'APP 设计',
          servText: '设计直观、美观的移动应用界面，注重用户体验，确保操作流畅性和视觉吸引力'
        },
        {
          id: 4,
          servTitle: '小程序',
          servText: '设计轻量级小程序，快速接入微信等平台，提供便捷的服务和高效的用户互动体验'
        },
        {
          id: 5,
          servTitle: '移动互联',
          servText: '构建跨平台移动解决方案，整合多种设备和服务，实现无缝连接和高效数据交换'
        },
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.Ben {
  margin-top: 80px;
  padding-bottom: 80px;
}

.banner-wrap {
  position: relative;
  width: 100%;
  height: 600px;
  margin-bottom: 50px;
  background-color: #f8931f;
  .banner-text {
    position: absolute;
    top: 30%;
    left: 10%;
  }
  p {
    font-size: 68px;
    color: #fff;
    font-weight: bold;
    line-height: 110px;
  }

  img {
    position: absolute;
    right: 10%;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 400px;
    height: 400px;
    transform: rotate(-8deg);
  }
}
.service-wrap {
  width: 80%;
  margin: auto;
}
.service-list {
  display: flex;
  position: relative;
  width: 100%;
  height: 350px;
  margin-top: 45px;
  justify-content: space-between;

  .service-item {
    width: 18%;
    height: 100%;
    background-color: #333;

    &:hover {
      .serv-show {
        display: none;
      }

      .serv-hover {
        display: block;
      }
    }
  }

  .serv-show {
    display: block;
    height: 100%;
    line-height: 350px;
    text-align: center;
    background-image: linear-gradient(to bottom right, #e4b577 , #db861e);

    .serv-icon {
      display: inline-block;
      width: 42px;
      height: 48px;
      margin-bottom: 22px;
      background-size: cover;
    }

    .serv-title {
      color: #fff;
      font-weight: bold;
      font-size: 32px;
    }
  }

  .serv-hover {
    display: none;
    width: 100%;
    height: 100%;
    background-color: #419afe;

    .serv-title {
      position: relative;
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-weight: 500;
      color: #fff;
      font-size: 24px;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 10%;
        right: 10%;
        border: 1px dashed #fff;
        opacity: .4;
      }
    }

    .serv-text {
      padding: 18px 30px;
      font-size: 18px;
      color: #fff;
      text-align: justify;
    }
  }
}
</style>